import React from 'react';
import Icon from 'components/AppIcon';

const CONFIDENCE_COLORS = {
  high: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500' },
  medium: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', dot: 'bg-amber-500' },
  low: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200', dot: 'bg-red-500' },
};

const TYPE_ICONS = {
  opportunity: { icon: 'TrendingUp', color: 'var(--color-success)' },
  warning: { icon: 'AlertTriangle', color: 'var(--color-warning)' },
  anomaly: { icon: 'Zap', color: 'var(--color-secondary)' },
  trend: { icon: 'BarChart2', color: 'var(--color-primary)' },
  forecast: { icon: 'Target', color: 'var(--color-accent)' },
};

export default function InsightCard({ insight, onViewDetails }) {
  const conf = CONFIDENCE_COLORS?.[insight?.confidence] || CONFIDENCE_COLORS?.medium;
  const typeConfig = TYPE_ICONS?.[insight?.type] || TYPE_ICONS?.trend;

  return (
    <div className={`card p-4 lg:p-5 kpi-card-glow cursor-pointer transition-smooth`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="flex items-center justify-center rounded-lg flex-shrink-0"
            style={{ width: 40, height: 40, background: `${typeConfig?.color}18` }}
          >
            <Icon name={typeConfig?.icon} size={20} color={typeConfig?.color} strokeWidth={2} />
          </div>
          <div className="min-w-0">
            <p className="font-heading font-semibold text-sm md:text-base text-foreground line-clamp-2 leading-tight">
              {insight?.title}
            </p>
            <p className="font-caption text-xs text-muted-foreground mt-0.5">{insight?.category} · {insight?.date}</p>
          </div>
        </div>
        <span className={`flex-shrink-0 flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${conf?.bg} ${conf?.text} ${conf?.border}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${conf?.dot}`} />
          {insight?.confidence?.charAt(0)?.toUpperCase() + insight?.confidence?.slice(1)}
        </span>
      </div>
      <p className="font-body text-sm text-muted-foreground line-clamp-3 leading-relaxed">{insight?.summary}</p>
      <div className="flex items-center gap-3 flex-wrap">
        {insight?.metrics?.map((m, i) => (
          <div key={i} className="flex flex-col">
            <span className="font-data text-sm font-semibold text-foreground">{m?.value}</span>
            <span className="font-caption text-xs text-muted-foreground">{m?.label}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between pt-1 border-t border-border">
        <div className="flex items-center gap-1.5">
          <Icon name="MapPin" size={13} color="var(--color-muted-foreground)" strokeWidth={2} />
          <span className="font-caption text-xs text-muted-foreground">{insight?.territory}</span>
        </div>
        <button
          onClick={() => onViewDetails(insight)}
          className="flex items-center gap-1 font-caption text-xs font-medium text-primary hover:underline focus:outline-none"
        >
          View Details
          <Icon name="ChevronRight" size={13} color="var(--color-primary)" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}